(() => {
  const root = document.querySelector('[data-rp-product-reviews]');
  if (!root || root.dataset.rpReviewBound === 'true') return;
  if (document.querySelector('[data-rp-title-rating-slot][data-rp-review-source="app"]')) {
    root.hidden = true;
    return;
  }
  root.dataset.rpReviewBound = 'true';

  const controller = new AbortController();
  const { signal } = controller;
  const showAllButton = root.querySelector('[data-rp-review-action="show-all"]');
  const openButton = root.querySelector('[data-rp-review-action="open-form"][data-rp-review-target]');
  const dialog = openButton ? document.getElementById(openButton.dataset.rpReviewTarget) : null;
  const closeButton = dialog?.querySelector('[data-rp-review-close]');
  const retryButton = dialog?.querySelector('[data-rp-review-retry]');
  const scrollLockState = {};
  let reviewOpenedAt = 0;
  let previouslyFocusedElement = null;
  let ordersRequest = null;
  let reviewRequest = null;
  let ordersRequestId = 0;
  let reviewRequestId = 0;

  const normalizeSameOriginAppProxy = (value) => {
    const candidate = String(value || '').trim();
    if (!candidate || candidate.startsWith('//') || candidate.includes('\\')) return null;

    try {
      const url = new URL(candidate, window.location.origin);
      const isAppProxy =
        (url.protocol === 'http:' || url.protocol === 'https:') &&
        url.origin === window.location.origin &&
        url.pathname.startsWith('/apps/') &&
        !url.username &&
        !url.password;
      if (!isAppProxy) return null;
      url.hash = '';
      return url.pathname + url.search;
    } catch {
      return null;
    }
  };
  const lockPageScroll = () => {
    if (document.documentElement.classList.contains('rp-review-scroll-locked')) return;

    scrollLockState.y = window.scrollY || document.documentElement.scrollTop || 0;
    scrollLockState.htmlOverflow = document.documentElement.style.overflow;
    scrollLockState.bodyPosition = document.body.style.position;
    scrollLockState.bodyTop = document.body.style.top;
    scrollLockState.bodyLeft = document.body.style.left;
    scrollLockState.bodyRight = document.body.style.right;
    scrollLockState.bodyWidth = document.body.style.width;
    scrollLockState.bodyOverflow = document.body.style.overflow;

    document.documentElement.classList.add('rp-review-scroll-locked');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollLockState.y + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  };

  const unlockPageScroll = () => {
    if (!document.documentElement.classList.contains('rp-review-scroll-locked')) return;

    const scrollY = Number(scrollLockState.y || 0);
    document.documentElement.classList.remove('rp-review-scroll-locked');
    document.documentElement.style.overflow = scrollLockState.htmlOverflow || '';
    document.body.style.position = scrollLockState.bodyPosition || '';
    document.body.style.top = scrollLockState.bodyTop || '';
    document.body.style.left = scrollLockState.bodyLeft || '';
    document.body.style.right = scrollLockState.bodyRight || '';
    document.body.style.width = scrollLockState.bodyWidth || '';
    document.body.style.overflow = scrollLockState.bodyOverflow || '';
    window.scrollTo(0, scrollY);
  };

  showAllButton?.addEventListener('click', () => {
    root.querySelectorAll('.rp-review-card--extra[hidden]').forEach((card) => {
      card.hidden = false;
    });
    showAllButton.hidden = true;
  }, { signal });

  openButton?.addEventListener('click', () => {
    if (dialog?.showModal && !dialog.open) {
      previouslyFocusedElement = document.activeElement;
      dialog.showModal();
      reviewOpenedAt = Date.now();
      loadOrders();
      lockPageScroll();
      window.requestAnimationFrame(() => closeButton?.focus());
    }
  }, { signal });

  dialog?.addEventListener('close', () => {
    unlockPageScroll();
    previouslyFocusedElement?.focus?.();
    previouslyFocusedElement = null;
  }, { signal });
  closeButton?.addEventListener('click', () => {
    dialog.close();
  }, { signal });

  dialog?.addEventListener('click', (event) => {
    if (event.target !== dialog) return;

    const rect = dialog.getBoundingClientRect();
    const clickedInsideDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (!clickedInsideDialog) dialog.close();
  }, { signal });

  const form = dialog?.querySelector('form.rp-review-dialog__form');
  const usesAppProxy = form?.hasAttribute('data-rp-review-form') || false;
  const message = dialog?.querySelector('[data-rp-review-message]');
  const submitButton = dialog?.querySelector('[data-rp-review-submit]');
  const honeypot = form?.elements.namedItem('website');
  const ratingStars = dialog?.querySelector('[data-rp-rating-stars]');
  const ratingInputs = [...(dialog?.querySelectorAll('input[data-rp-star-value]') || [])];
  const ratingLabels = ratingInputs.map((input) => input.closest('label')).filter(Boolean);
  let selectedRating = Number(ratingInputs.find((input) => input.checked)?.value || 0);

  const renderRating = (value) => {
    const rating = Number(value || selectedRating || 0);

    ratingInputs.forEach((input) => {
      const starValue = Number(input.dataset.rpStarValue);
      const label = input.closest('label');
      input.checked = starValue === selectedRating;
      input.setAttribute('aria-checked', starValue === selectedRating ? 'true' : 'false');
      label?.classList.toggle('is-active', starValue <= rating);
    });

    const ratingOutput = dialog?.querySelector('[data-rp-rating-output]');
    if (ratingOutput) {
      const template = ratingStars?.dataset.rpRatingTemplate || '__rating__';
      ratingOutput.textContent = rating ? template.replace('__rating__', String(rating)) : '';
    }
  };

  const setRating = (value) => {
    selectedRating = Number(value || 0);
    renderRating(selectedRating);
  };

  ratingLabels.forEach((label) => {
    label.addEventListener('mouseenter', () => {
      const input = label.querySelector('input[data-rp-star-value]');
      renderRating(input?.dataset.rpStarValue || 0);
    }, { signal });
  });

  ratingInputs.forEach((input) => {
    input.addEventListener('change', () => setRating(input.value), { signal });
    input.addEventListener('focus', () => renderRating(input.value), { signal });
  });

  ratingStars?.addEventListener('mouseleave', () => renderRating(selectedRating), { signal });
  ratingStars?.addEventListener('focusout', () => renderRating(selectedRating), { signal });
  renderRating(selectedRating);

  const orderSelect = dialog?.querySelector('[data-rp-order-select]');
  const orderReference = dialog?.querySelector('[data-rp-order-reference]');
  const orderDetails = dialog?.querySelector('[data-rp-order-details]');
  const manualOrder = dialog?.querySelector('[data-rp-manual-order]');
  const manualOrderInput = dialog?.querySelector('[data-rp-manual-order-input]');
  const orderSelectLabel = orderSelect
    ? [...dialog.querySelectorAll('label')].find((label) => label.htmlFor === orderSelect.id)
    : null;

  const showOrdersFallback = (allowRetry) => {
    if (orderSelect) {
      orderSelect.disabled = true;
      orderSelect.required = false;
      orderSelect.hidden = true;
    }
    if (orderSelectLabel) orderSelectLabel.hidden = true;
    if (orderReference) orderReference.disabled = true;
    if (orderDetails) orderDetails.hidden = true;
    if (manualOrder) manualOrder.hidden = false;
    if (manualOrderInput) {
      manualOrderInput.disabled = false;
      manualOrderInput.required = true;
    }
    if (retryButton) retryButton.hidden = !allowRetry;
    if (message) {
      message.textContent = form?.dataset.rpReviewOrdersError || '';
      message.hidden = !message.textContent;
      message.classList.remove('is-success');
      message.classList.add('is-error');
    }
  };

  const restoreOrdersSelect = () => {
    if (!orderSelect) return;
    orderSelect.disabled = false;
    orderSelect.required = true;
    orderSelect.hidden = false;
    if (orderSelectLabel) orderSelectLabel.hidden = false;
    if (orderReference) orderReference.disabled = false;
    if (manualOrder) manualOrder.hidden = true;
    if (manualOrderInput) {
      manualOrderInput.disabled = true;
      manualOrderInput.required = false;
      manualOrderInput.value = '';
    }
    if (retryButton) retryButton.hidden = true;
    if (message) {
      message.textContent = '';
      message.hidden = true;
      message.classList.remove('is-error');
    }
  };

  const updateOrder = () => {
    if (!orderSelect) return;
    const selected = orderSelect.options[orderSelect.selectedIndex];
    if (orderReference) orderReference.value = orderSelect.value;
    if (orderDetails) {
      const items = selected?.dataset.rpOrderItems || '';
      orderDetails.textContent = items;
      orderDetails.hidden = !items;
    }
  };

  orderSelect?.addEventListener('change', updateOrder, { signal });
  updateOrder();

  let ordersLoaded = false;
  async function loadOrders() {
    const ordersEndpoint = normalizeSameOriginAppProxy(orderSelect?.dataset.rpOrdersUrl);
    const productId = orderSelect?.dataset.rpProductId;
    if (!orderSelect || ordersLoaded) return;
    if (!ordersEndpoint || !productId) {
      showOrdersFallback(false);
      return;
    }

    ordersRequest?.controller.abort();
    const requestId = ++ordersRequestId;
    const controller = new AbortController();
    let timedOut = false;
    const timeout = window.setTimeout(() => {
      timedOut = true;
      controller.abort();
    }, 10000);
    ordersRequest = { controller, requestId };
    ordersLoaded = true;

    try {
      const requestUrl = new URL(ordersEndpoint, window.location.origin);
      requestUrl.searchParams.set('product_id', productId);
      const response = await fetch(requestUrl.toString(), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: controller.signal
      });
      const data = await response.json().catch(() => ({}));
      if (requestId !== ordersRequestId || controller.signal.aborted) return;
      if (!response.ok || !Array.isArray(data.orders) || data.orders.length === 0) throw new Error('orders_unavailable');

      let validOrderCount = 0;
      data.orders.forEach((order) => {
        const option = document.createElement('option');
        option.value = String(order.id || order.name || '');
        option.textContent = [order.name, order.created_at].filter(Boolean).join(' - ');
        option.dataset.rpOrderItems = Array.isArray(order.items)
          ? order.items.map((item) => `${item.quantity || 1} x ${item.title || ''}`).join(' - ')
          : String(order.items || '');
        option.dataset.rpOrderOption = 'true';
        if (option.value) {
          orderSelect.append(option);
          validOrderCount += 1;
        }
      });
      if (validOrderCount === 0) throw new Error('orders_unavailable');
      restoreOrdersSelect();
      updateOrder();
    } catch (error) {
      if (requestId !== ordersRequestId || (error.name === 'AbortError' && !timedOut)) return;
      ordersLoaded = false;
      showOrdersFallback(true);
    } finally {
      window.clearTimeout(timeout);
      if (ordersRequest?.requestId === requestId) ordersRequest = null;
    }
  }

  retryButton?.addEventListener('click', () => {
    if (!orderSelect) return;
    orderSelect.querySelectorAll('option[data-rp-order-option]').forEach((option) => option.remove());
    restoreOrdersSelect();
    ordersLoaded = false;
    loadOrders();
  }, { signal });
  const showMessage = (text, state) => {
    if (!message) return;
    message.textContent = text;
    message.hidden = false;
    message.classList.remove('is-success', 'is-error');
    message.classList.add(state);
  };

  form?.addEventListener('submit', async (event) => {
    if (!usesAppProxy) return;

    event.preventDefault();

    if (!selectedRating) {
      form.reportValidity();
      ratingInputs[0]?.focus();
      return;
    }

    const minSubmitMs = Number(form.dataset.rpReviewMinSubmitMs || 0);
    const submittedTooQuickly = reviewOpenedAt > 0 && Date.now() - reviewOpenedAt < minSubmitMs;
    if (honeypot?.value || submittedTooQuickly) {
      showMessage(form.dataset.rpReviewError, 'is-error');
      return;
    }

    const reviewEndpoint = normalizeSameOriginAppProxy(form.action);
    if (!reviewEndpoint) {
      showMessage(form.dataset.rpReviewError, 'is-error');
      return;
    }

    if (reviewRequest) return;

    const requestId = ++reviewRequestId;
    const controller = new AbortController();
    let timedOut = false;
    const timeout = window.setTimeout(() => {
      timedOut = true;
      controller.abort();
    }, 10000);
    reviewRequest = { controller, requestId };
    if (submitButton) submitButton.disabled = true;
    if (message) {
      message.hidden = true;
      message.classList.remove('is-success', 'is-error');
    }

    try {
      const response = await fetch(reviewEndpoint, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(new FormData(form)),
        signal: controller.signal
      });
      const data = await response.json().catch(() => ({}));
      if (requestId !== reviewRequestId || controller.signal.aborted) return;
      if (!response.ok || data.ok === false) throw new Error('review_submit_failed');

      form.reset();
      setRating(0);
      updateOrder();
      showMessage(form.dataset.rpReviewSuccess, 'is-success');
    } catch (error) {
      if (requestId !== reviewRequestId) return;
      if (timedOut) {
        showMessage(form.dataset.rpReviewTimeout || form.dataset.rpReviewError, 'is-error');
      } else if (error.name !== 'AbortError') {
        showMessage(form.dataset.rpReviewError, 'is-error');
      }
    } finally {
      window.clearTimeout(timeout);
      if (reviewRequest?.requestId === requestId) reviewRequest = null;
      if (submitButton) submitButton.disabled = false;
    }
  }, { signal });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target === root || event.target.contains?.(root)) {
      unlockPageScroll();
      ordersRequest?.controller.abort();
      reviewRequest?.controller.abort();
      controller.abort();
      root.dataset.rpReviewBound = 'false';
    }
  }, { signal });
})();
